import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import PersonalInformation from './pages/PersonalInformation';
import ContactAndCommunication from './pages/ContactAndCommunication';
import AddressAndIdentity from './pages/AddressAndIdentity';
import EmergencyAndBilling from './pages/EmergencyAndBilling';
import CareAndInsurance from './pages/CareAndInsurance';
import MedicalHistory from './pages/MedicalHistory';
import WellnessCheck from './pages/WellnessCheck';
import ReviewAndSign from './pages/ReviewAndSign';
import Payments from './pages/Payments';
import Completion from './pages/Completion';
import { MasterDataProvider } from './contexts/MasterDataContext';
import { DemographicsProvider } from './contexts/DemographicsContext';
import { WorkflowProvider } from './contexts/WorkflowContext';
import { LoaderProvider } from './contexts/LoaderContext';
import { useParams } from 'react-router-dom';

const QuestionnaireWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { appointmentId } = useParams<{ appointmentId: string }>();
  
  return (
    <MasterDataProvider>
      <DemographicsProvider appointmentId={appointmentId}>
        {children}
      </DemographicsProvider>
    </MasterDataProvider>
  );
};

const ConditionalWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isIndependentPage = location.pathname.includes('/payments') ||
                            location.pathname.includes('/medical-history') ||
                            location.pathname.includes('/wellness-check') ||
                            location.pathname.includes('/review-and-sign') ||
                            location.pathname.includes('/complete');
  
  if (isIndependentPage) {
    return <>{children}</>;
  }
  
  return <QuestionnaireWrapper>{children}</QuestionnaireWrapper>;
};

const QuestionnaireRoutes = () => {
  return (
    <LoaderProvider>
      <WorkflowProvider>
        <ConditionalWrapper>
          <Routes>
            <Route path="personal-information" element={<PersonalInformation />} />
            <Route path="contact-and-communication" element={<ContactAndCommunication />} />
            <Route path="address-and-identity" element={<AddressAndIdentity />} />
            <Route path="emergency-and-billing" element={<EmergencyAndBilling />} />
            <Route path="care-and-insurance" element={<CareAndInsurance />} />
            <Route path="medical-history" element={<MedicalHistory />} />
            <Route path="wellness-check" element={<WellnessCheck />} />
            <Route path="review-and-sign" element={<ReviewAndSign />} />
            <Route path="payments" element={<Payments />} />
            <Route path="complete" element={<Completion />} />
          </Routes>
        </ConditionalWrapper>
      </WorkflowProvider>
    </LoaderProvider>
  );
};

export default QuestionnaireRoutes;